import admin from '@innovyze/stylovyze/lib/apis/auth.api';
const baseEndpoint = '/subscriptions-usage';
export const getSubscriptionsUsageService = () => admin.get(`${baseEndpoint}`);
